import React, { ComponentProps, useCallback, useEffect, useState } from 'react';

import { Autocomplete, Checkbox, TextField } from '@mui/material';

import { getCountriesVisitedList } from '~/services/ToursService';
import { ReqInstance } from '~/services/types';

interface Props {
  value: Array<string>;
  onChange: (newValue?: Array<string>) => void;
}

export default function TourOfferCountryInput({ value, onChange }: Props) {
  const [countriesReq, setCountriesReq] = useState<ReqInstance<Array<string>>>({
    status: 'uninitiated',
  });

  const fetchCountries = useCallback(async () => {
    setCountriesReq({ status: 'pending' });
    try {
      const res = await getCountriesVisitedList();
      setCountriesReq({ status: 'succeeded', result: res.result.countries });
    } catch (err) {
      setCountriesReq({ status: 'failed', error: err });
    }
  }, []);

  useEffect(() => {
    fetchCountries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = useCallback<ComponentProps<typeof Autocomplete>['onChange']>(
    (e, value: Array<string>) => {
      onChange(value);
    },
    [onChange],
  );

  return (
    <Autocomplete
      value={value}
      onChange={handleChange}
      fullWidth
      multiple
      disabled={countriesReq.status === 'failed'}
      loading={countriesReq.status === 'pending'}
      options={countriesReq.status === 'succeeded' ? countriesReq.result : []}
      openOnFocus
      disableCloseOnSelect
      getOptionLabel={(option: string) => option}
      renderOption={(props, option: string, { selected }) => (
        <li {...props}>
          <Checkbox checked={selected} />
          {option}
        </li>
      )}
      renderInput={(params) => <TextField {...params} label="Countries" />}
    />
  );
}
